import { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import mapProps from 'map-props';
import propsMapping from './propsMapping';

class SellWidget extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    html: PropTypes.string,
    js: PropTypes.string,
    onDidMount: PropTypes.func,
  };

  state = {
    isMounted: false,
  };

  componentDidMount() {
    const { onDidMount } = this.props;

    this.setState({ isMounted: true }, () => {
      if (onDidMount) {
        this.timeoutId = setTimeout(onDidMount, 200);
      }
    });
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    const { html, js, className } = this.props;
    const { isMounted } = this.state;

    return (
      <Fragment>
        {html ? (
          <div
            className={className}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ) : null}

        {isMounted && js ? (
          <Helmet>
            <script>{js}</script>
          </Helmet>
        ) : null}
      </Fragment>
    );
  }
}

export default mapProps(propsMapping)(SellWidget);
